import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCompare,
  GuideContrast,
} from "../GuideBlocks.js";

const MentalNoiseVsOverthinkingSection = ({ heading, accentIndex = 3, getVisual, getAccent }) => (
  <GuidePanel sectionId="mental-noise-vs-overthinking" heading={heading} accentIndex={accentIndex} getVisual={getVisual} getAccent={getAccent}>
    <GuideLead>Although related, mental noise and overthinking are not the same.</GuideLead>
    <GuideCompare
      leftTitle="Mental Noise"
      rightTitle="Overthinking"
      left={
        <>
          <p>The constant background activity of the mind.</p>
          <p>
            It consists of multiple stories, emotional memories, assumptions, and internal
            conversations competing for attention.
          </p>
        </>
      }
      right={
        <>
          <p>
            Repeatedly analysing a single situation without reaching a useful conclusion.
          </p>
        </>
      }
    />
    <GuideContrast
      items={[
        {
          title: "Mental noise creates the environment.",
          text: "It is the backdrop of competing internal signals.",
        },
        {
          title: "Overthinking is one expression of that environment.",
          text: "It is a symptom, not the root cause.",
        },
      ]}
    />
    <p className="guide-panel__p">
      A useful test: analysis produces new information or a decision; rumination repeats the same
      question without either. If you have circled a situation three times and nothing new has emerged,
      you are no longer analysing — you are ruminating. That is the moment to write the interpretation
      down and check it against the facts instead of running the loop again.
    </p>
  </GuidePanel>
);

export default MentalNoiseVsOverthinkingSection;
